export const separateTextFromCenter = (text, count = 5) => {
  if (text?.length > 12) {
    return (
      text?.substring(0, count) + " .... " + text?.substring(text.length - 5)
    );
  } else {
    return text;
  }
};
